import { useEffect, useState } from "react";

const Unauthorized = () => {
  const [flash, setFlash] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setFlash(true);
      setTimeout(() => setFlash(false), 100);
    }, 2500);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white relative overflow-hidden font-mono ">

      {flash && (
        <div className="absolute inset-0 bg-white opacity-80 z-50 animate-ping" />
      )}

      <div className="bg-zinc-900 border border-zinc-700 shadow-2xl rounded-2xl p-8 text-center max-w-md w-full relative z-10">
        
        <div className="text-6xl mb-4 animate-bounce">📸</div>

        <h1 className="text-3xl font-bold text-red-500 mb-2">
          ACCESS DENIED (Flash warning)
        </h1>

        <p className="text-gray-300 mb-4">
          🚨 You tried to access a restricted area.
        </p>

        <p className="text-sm text-gray-500 mb-6">
          Your face has been captured and sent to our highly trained AI pigeons 🐦‍⬛
        </p>

        <div className="h-1 w-full bg-red-500 animate-pulse mb-6 rounded-full"></div>

        <div className="flex gap-3 justify-center">
          <button
            onClick={() => window.history.back()}
            className="px-4 py-2 rounded-lg bg-zinc-700 hover:bg-zinc-600 transition"
          >
            Retreat 🏃
          </button>

          <button
            onClick={() => (window.location.href = "/")}
            className="px-4 py-2 rounded-lg bg-red-600 hover:bg-red-700 transition"
          >
            Go Home 🏠
          </button>
        </div>

        {/* Footer joke */}
        <p className="text-xs text-gray-600 mt-6">
          System log: Unauthorized human detected 🤖
        </p>
      </div>
    </div>
  );
};

export default Unauthorized;